import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
  Container,
  TextField,
  Checkbox,
  Button,
  FormControlLabel,
  Grid,
  Card,
  CardMedia,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Select,
  MenuItem,
  InputLabel,
  Snackbar,
} from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import QRCode from 'qrcode.react'; // Importa el componente QRCode
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import {
  API_BASE_URL,
  PRODUCTOALTA,
  PRODUCTOEDITAR,
  RUTAPRODUCTOSIMAGENES,
  PRODUCTOFOTOS,
  ELIMINARFOTO,
  RUBROSLISTAR,BASE_URL_QR
} from '../services/apiConfig';
import { MenuInicial } from './MenuInicial';
import { registrarAuditoria, isAuthenticated } from '../services/api.js';

const ProductoAMC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [showImageLimitError, setShowImageLimitError] = useState(false);
  const [productData, setProductData] = useState({
    id: '',
    nombre: '',
    descripcion: '',
    activo: false,
    precio: '',
    unidades: '',
    fotos: [],
    fotoPredeterminada: '', // Almacena la ruta de la imagen predeterminada
  });
  const userData = JSON.parse(sessionStorage.getItem("userData"));
  const usuarioid = userData?.usuarioid;
  const perfil = userData?.perfil;
  const [imageToDelete, setImageToDelete] = useState(null);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [imagePreview, setImagePreview] = useState('');
  const [imageUploaded, setImageUploaded] = useState(false);
  const [localImages, setLocalImages] = useState([]); // Almacena las imágenes seleccionadas localmente
  const [rubros, setRubros] = useState([]);
  const [selectedRubro, setSelectedRubro] = useState('');
  const [rubroError, setRubroError] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false); // Estado para determinar el modo

  useEffect(() => {
    /*const loggedIn = sessionStorage.getItem('loggedIn');
    if (!loggedIn) {
      navigate('/login');
    }*/

    const autenticado = isAuthenticated();
    if (autenticado===false) {
      navigate("/login");
    }

    if (location.state && location.state.productToEdit) {
      const productToEdit = location.state.productToEdit;
      obtenerRutasDeImagenes(productToEdit.id).then((rutas) => {
        setProductData({
          ...productToEdit,
          fotos: rutas,
          activo: productToEdit.activo === 1 || productToEdit.activo === '1' ? true : false,
        });
        // Preseleccionar el rubro del producto al editar
        setSelectedRubro(productToEdit.rubroid);
        setIsEditMode(true); // Establecer en modo edición
      });
    }

    const fetchRubros = async () => {
      try {
        const response = await axios.get(API_BASE_URL + RUBROSLISTAR);
        setRubros(response.data);
      } catch (error) {
        console.error('Error al obtener los rubros:', error);
      }
    };

    fetchRubros();
  }, [navigate, location.state]);

  const obtenerRutasDeImagenes = async (productId) => {
    try {
      const response = await axios.get(API_BASE_URL + PRODUCTOFOTOS + '?id=' + productId);
      return response.data.rutas;
    } catch (error) {
      console.error('Error al obtener rutas de imágenes:', error);
      return [];
    }
  };

  const eliminarImagen = async () => {
    try {
      if (imageToDelete) {
        await axios.post(API_BASE_URL + ELIMINARFOTO, { ruta: imageToDelete, productoid: productData.id });
        setProductData({
          ...productData,
          fotos: productData.fotos.filter((ruta) => ruta !== imageToDelete),
        });
        setDeleteDialogOpen(false);
      }
    } catch (error) {
      console.error('Error al eliminar la imagen:', error);
    }
  };

  const handleInputChange = (event) => {
    const { name, value, type, checked } = event.target;
    const newValue = type === 'checkbox' ? checked : value;
    setProductData({
      ...productData,
      [name]: name === 'activo' ? checked : newValue,
    });
  };

  const handleFileChange = (event) => {
    const files = event.target.files;

    if (files.length > 0 && productData.fotos.length === 0) { // Verifica si no hay imágenes asociadas
      const primeraImagen = files[0];
      setLocalImages([primeraImagen]);

      const reader = new FileReader();
      reader.onload = (e) => {
        setImagePreview(e.target.result);
      };
      reader.readAsDataURL(primeraImagen);
      setImageUploaded(true);
      // Resto del código para cargar la imagen...
    } else {
      // Indica al usuario que ya existe una imagen asociada y no se puede agregar otra.
      //alert('El producto ya tiene una imagen asociada, debe eliminarla primero');
      setShowImageLimitError(true);
      // Puedes mostrar un mensaje, deshabilitar el botón o realizar alguna acción para informar al usuario.
    }
  };

  const eliminarImagenNueva = () => {
    setLocalImages([]);
  };

  const handleFormSubmit = async (event) => {
    event.preventDefault();

    if (!selectedRubro) {
      setRubroError(true);
      return;
    } else {
      setRubroError(false);
    }

    const formData = new FormData();
    formData.append('nombre', productData.nombre);
    formData.append('descripcion', productData.descripcion);
    formData.append('activo', productData.activo);
    formData.append('precio', productData.precio);
    formData.append('unidades', productData.unidades);

    productData.fotos.forEach((foto, index) => {
      if (foto !== null) {
        formData.append(`foto${index}`, foto);
      }
    });

    // Agrega las imágenes seleccionadas localmente al formulario
    localImages.forEach((localImage, index) => {
      formData.append(`nuevaFoto${index}`, localImage);
    });

    // Agrega la imagen predeterminada al formulario
    formData.append('fotoPredeterminada', productData.predeterminada);

    // Agrega el rubro seleccionado al formulario
    formData.append('rubro', selectedRubro);

    try {
      if (productData.id) {
        formData.append('productoid', productData.id);
        await axios.post(
          `${API_BASE_URL}${PRODUCTOEDITAR}/${productData.id}`,
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          }
        );

        await registrarAuditoria( //operacion,tabla,clave,campo,datoanterior,datoactualizado,aplicacion, usuario
          'Editar', // operación
          'Producto', // tabla
          productData.id + ' - ' + productData.descripcion, // clave
          'todos', // campo
          '', // datoanterior
          '', // datoactualizado
          'ProductoAMC', // aplicacion
          usuarioid // usuario (reemplaza con el ID del usuario actual)
        );

      } else {
        await axios.post(API_BASE_URL + PRODUCTOALTA, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
      }

      navigate('/ProductoList');
    } catch (error) {
      console.error('Error al crear/editar el producto:', error);
    }
  };

  const handleImageCheckboxChange = (event, foto) => {
    const isChecked = event.target.checked;
    setProductData({
      ...productData,
      fotoPredeterminada: isChecked ? foto : 'nopredeterminada',
    });
  };

  // Define el valor del código QR, puede ser cualquier string, aquí uso el ID del producto
  const qrValue = `${BASE_URL_QR}=${productData.id}`;

  const downloadQRCode = () => {
    const input = document.getElementById('qrCodeElement');
    html2canvas(input).then((canvas) => {
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF();
      pdf.addImage(imgData, 'PNG', 10, 10);
      pdf.save(`QRCode_${productData.id}.pdf`);
    });
  };

  
  return (
    <Container>
      <MenuInicial />
      <div className="miDiv">
      <h2>{isEditMode ? 'Editar Producto' : 'Crear Producto'}</h2>
      </div>
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={showImageLimitError}
        autoHideDuration={4000}
        onClose={() => setShowImageLimitError(false)}
        message="El producto ya tiene una imagen asociada, debe eliminarla primero."
      />
      <div style={{ display: 'flex', justifyContent: 'left' }}>
        <form onSubmit={handleFormSubmit} style={{ maxWidth: '400px', width: '100%' }}>
          <Grid container spacing={2}>
          {isEditMode && (
            <Grid item xs={12}>
              <TextField
                label="ID"
                name="id"
                value={productData.id}
                onChange={handleInputChange}
                disabled
                fullWidth
              />
            </Grid>
            )}
            {isEditMode && Number(perfil) === 1 && (
            <Grid item xs={12}  >
              <QRCode id="qrCodeElement" value={qrValue} /> {/* Agrega el componente QRCode */}
              
              <Button
                variant="contained"
                color="primary"
                onClick={downloadQRCode}
                fullWidth
              >
                Descargar QR como PDF
              </Button>

              </Grid>
            
            )}
          
            <Grid item xs={12}>
              <TextField
                label="Nombre"
                name="nombre"
                value={productData.nombre}
                onChange={handleInputChange}
                fullWidth
                required
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Descripción"
                name="descripcion"
                value={productData.descripcion}
                onChange={handleInputChange}
                fullWidth
                required
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Precio"
                name="precio"
                value={productData.precio}
                onChange={handleInputChange}
                fullWidth
                required
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Unidades"
                name="unidades"
                value={productData.unidades}
                onChange={handleInputChange}
                fullWidth
                required
              />
            </Grid>
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={productData.activo}
                    onChange={handleInputChange}
                    name="activo"
                  />
                }
                label="Activo"
              />
            </Grid>
            <Grid item xs={12}>
              <InputLabel id="rubro-label">Rubro</InputLabel>
              <Select
                labelId="rubro-label"
                value={selectedRubro}
                onChange={(event) => setSelectedRubro(event.target.value)}
                fullWidth
                required
                error={rubroError}
              >
                {rubros.map((rubro) => (
                  <MenuItem key={rubro.id} value={rubro.id}>
                    {rubro.nombre}
                  </MenuItem>
                ))}
              </Select>
              {rubroError && <Typography color="error">Debe seleccionar un rubro</Typography>}
            </Grid>
            <Grid item xs={12}>
              <Button
                variant="contained"
                component="label"
                fullWidth
                color="primary"
              >
                Seleccionar Imagen
                <input
                  type="file"
                  hidden
                  onChange={handleFileChange}
                />
              </Button>
            </Grid>
            {imagePreview && (
              <Grid item xs={12}>
                <Card>
                  <CardMedia
                    component="img"
                    image={imagePreview}
                    title="Imagen seleccionada"
                  />
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={eliminarImagenNueva}
                  >
                    Eliminar Imagen
                  </Button>
                </Card>
              </Grid>
            )}
           
            <Grid item xs={12}>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                fullWidth
              >
                Guardar
              </Button>
            </Grid>
          </Grid>
        </form>
      </div>
      <Dialog open={deleteDialogOpen} onClose={() => setDeleteDialogOpen(false)}>
        <DialogTitle>Confirmar eliminación</DialogTitle>
        <DialogContent>
          <Typography>
            ¿Está seguro de que desea eliminar esta imagen?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteDialogOpen(false)} color="primary">
            Cancelar
          </Button>
          <Button onClick={eliminarImagen} color="secondary">
            Eliminar
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default ProductoAMC;
